import { requestHelpers } from '../../../../../helpers';

export const actions = {
    SET_VISIBILITY: "SET_VISIBILITY",
    GENERAL_VISIBILITY_REQUEST: "GENERAL_VISIBILITY_REQUEST",
    GENERAL_VISIBILITY_SUCCESS: "GENERAL_VISIBILITY_SUCCESS",
    GENERAL_VISIBILITY_ERROR: "GENERAL_VISIBILITY_ERROR",
}

export const setVisibility = ( profile ) => {
    return {
        type: actions.SET_VISIBILITY,
        personId: profile.id,
        visible: profile.profile[0].visible,
        networkId: profile.profile[0].network_id,
    }
}

export const changeVisibility = ( personId, flag, networkId ) => {
    const visible = !flag ? "hide" : "show";
    return (dispatch) => {
        requestHelpers
            .authenticatedPostRequest(`/profiles/${personId}/${ visible }?network_id=${ networkId }`)
            .then((response) => {
                return dispatch({
                    type: actions.GENERAL_VISIBILITY_SUCCESS,
                    visible: flag,
                })
            })
    }

}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/visibility.js